import { render, staticRenderFns } from "./exchageDialog.vue?vue&type=template&id=5566cc40&scoped=true&"
import script from "./exchageDialog.vue?vue&type=script&lang=js&"
export * from "./exchageDialog.vue?vue&type=script&lang=js&"
import style0 from "./exchageDialog.vue?vue&type=style&index=0&id=5566cc40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5566cc40",
  null
  
)

export default component.exports